module.exports = __webpack_public_path__ + "img/53ab584.jpg";